/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo } from "react";
import { subYears, format } from "date-fns";
import { useFormikContext, Field } from "formik";
import { useSelector, useDispatch } from "react-redux";
import options from "components/PLCTABS/SFLdata/selectOptions";
import DatePickerField from "components/lib/Shared/DatePickerField";
import Input from "components/lib/Shared/Input";
import ChangesContext from "context/ChangesContext";
import { openModal, closeModal } from "state/slices/modals";
import ReactSelectWithFormik from "components/lib/Shared/DropdownSelect";
import ChangeOfNationalityConfirmationModal from "components/lib/Shared/CompanyDashboard/ChangesModule/ChangeOfNationalityConfirmationModal";

const MODAL_NAME = "change_of_nationality_confirmation_modal";
// Identification Details for Kenyan Citizen
const IdentificationDetailsKeCi = ({
  form,
  field,
  idType,
  setNationalityChangeForm,
  disabled,
  setDisableForm,
}) => {
  const dispatch = useDispatch();
  const maxDateOfBirth = subYears(new Date(), 18);
  const [startDate, setStartDate] = useState("");
  const [selectedNationality, setSelectedNationality] = useState(null);
  const { setFieldValue } = useFormikContext();
  const countriesOptions = useMemo(() => {
    return options.countries.map((country) => {
      if (["Kenyan Citizen"].includes(idType) && country.value === "KE") {
        return { ...country, disabled: true };
      }
      return country;
    });
  }, [idType, options.countries]);

  const handleSelect = (type) => (option) => {
    if (type === "nationality") {
      setSelectedNationality(option.value);
      dispatch(openModal({ modalName: MODAL_NAME }));
    }
  };

  const handleSetValue = (e) => {
    const value =
      e.target.type === "number" ? parseInt(e.target.value) : e.target.value;
    setFieldValue(field.name, {
      ...field.value,
      [e.target.name]: value,
    });
  };

  const handleChangeOfNationality = () => {
    if (selectedNationality) {
      setFieldValue(field.name, {
        ...field.value,
        nationality: selectedNationality,
      });
      setNationalityChangeForm(true);
      setDisableForm(true);
      setFieldValue("idType", null);
    }
    dispatch(closeModal({ modalName: MODAL_NAME }));
  };

  const { values } = form;
  const currentUser = useSelector((state) => state.userSlice);
  const isApplicant = values?.createdBy === currentUser._id;
  const areCSFieldsOptional =
    (values?._id ? isApplicant : true) &&
    (values?.type === "invited" || values?.hasAccess);

  const handleDateValue = (date) => {
    setFieldValue(field.name, {
      ...field.value,
      dateOfBirth: format(date, "yyyy/MM/dd"),
    });
    return setStartDate(date);
  };

  const selectedDOB =
    field.value && field.value.dateOfBirth
      ? new Date(field.value.dateOfBirth)
      : startDate;

  return (
    <div className="grid grid-cols-6 gap-6">
      <ChangeOfNationalityConfirmationModal
        modalName={MODAL_NAME}
        handleChangeOfNationality={handleChangeOfNationality}
        selectedNationality={
          options.countries.find(
            (country) => country.value === selectedNationality
          )?.label
        }
      />
      <div className="col-span-6 sm:col-span-2">
        <DatePickerField
          label="Date of Birth"
          onChange={handleDateValue}
          selected={selectedDOB}
          maxDate={maxDateOfBirth}
          form={form}
          name="dateOfBirth"
          placeholderText="Select date of birth"
          errorPath="identificationDetails.dateOfBirth"
          disabled={disabled}
        />
      </div>
      <div className="col-span-6 sm:col-span-2">
        <Input
          label="National ID Number"
          name="nationalIDNumber"
          placeholder="Enter national ID number"
          form={form}
          value={field.value?.nationalIDNumber ?? ""}
          errorPath="identificationDetails.nationalIDNumber"
          disabled={disabled}
          onBlur={field.onBlur}
          onChange={handleSetValue}
        />
      </div>
      <div className="col-span-6 sm:col-span-2">
        <Input
          label="KRA PIN"
          name="KRAPin"
          placeholder="Enter KRA PIN"
          value={field.value?.KRAPin ?? ""}
          form={form}
          errorPath="identificationDetails.KRAPin"
          disabled={disabled}
          onBlur={field.onBlur}
          onChange={handleSetValue}
        />
      </div>
      <div className="col-span-6 sm:col-span-2">
        <Input
          label="Occupation"
          name="occupation"
          placeholder="Enter occupation"
          form={form}
          value={field.value?.occupation ?? ""}
          errorPath="identificationDetails.occupation"
          disabled={disabled}
          onBlur={field.onBlur}
          onChange={handleSetValue}
        />
      </div>
      {/* <div className="col-span-6 sm:col-span-2">
        <Input
          label="Nationality"
          name="nationality"
          placeholder="KENYAN"
          form={form}
          value={"KENYAN"}
          errorPath="identificationDetails.nationality"
          onBlur={field.onBlur}
          onChange={handleSetValue}
        //disabled={true}
        />
      </div> */}
      <div className="col-span-6 sm:col-span-2">
        <Field
          {...field}
          label="Nationality"
          value={field?.value?.nationality ?? ""}
          name="nationality"
          component={ReactSelectWithFormik}
          options={countriesOptions}
          errorPath="identificationDetails.nationality"
          placeholder="Enter nationality"
          onBlur={field.onBlur}
          onChange={handleSelect("nationality")}
          isSearchable
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};

export default IdentificationDetailsKeCi;
